<template>
  <PModal
    :title="t('sessionIdle.title')"
    size="sm"
    modal-id="sessionExpiredModal"
    :dismissable-mask="false"
  >
    <template #modal-content>
      <div class="mt-3 text-center">
        <span class="fw-bold">{{ t('sessionIdle.description') }}</span>
      </div>
      <div class="mt-3 mb-3 text-center">
        <span class="time">{{ timerCount }}</span>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import AppIdle from '@app-idle/core'
import * as workerTimers from 'worker-timers'
import PModal from '@/components/PModal.vue'
import { auth } from '@/services'
import { eventBus } from '@/composables/useEventBus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const timerCount = ref(60)
let timeOutId: number | null = null

const appIdle = new AppIdle({
  timeout: 1800000,
  onIdle: () => onIdle(),
  onCancel: () => onCancel(),
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'wheel'],
  multi: true,
  storageKey: 'AppIdle',
  eventTarget: globalThis as unknown as Window,
})

function onIdle() {
  if (timeOutId) return
  eventBus.fire('show:sessionExpiredModal')
  timeOutId = workerTimers.setInterval(() => {
    timerCount.value -= 1
    if (timerCount.value === 0) auth.signOut()
  }, 1000)
}

function onCancel() {
  if (timeOutId) {
    workerTimers.clearInterval(timeOutId)
    timeOutId = null
    timerCount.value = 60
    eventBus.fire('hide:sessionExpiredModal')
  }
}

onMounted(() => appIdle.start())
onUnmounted(() => {
  appIdle.stop?.()
  if (timeOutId) {
    workerTimers.clearInterval(timeOutId)
    timeOutId = null
  }
})
</script>

<style lang="scss" scoped>
@use '../assets/scss/variables' as *;

.time {
  font-size: 50px;
  color: $prosegur-color;
}
</style>
